<div class="mb-0 card" (dragover)="onDragOver($event)" (drop)="onDropDependentItem($event, dragDropComponentType.DependentItem, group().ScopingItemId)">
  <div class="card-header" style="padding: 5px 10px">
    <div class="d-flex">
      <div data-toggle="tooltip" title=" {{group().ScopingItemNumber}} - {{group().ScopingItemName}}" class="text-truncate" style="padding-top:5px">
        {{group().ScopingItemNumber}} ({{group().ScopingItemName}})
      </div>
      <div class="ms-auto">
        <button type="button" kendoButton [svgIcon]="icons.close" (click)="removeGroup(group()); $event.stopPropagation()"></button>
      </div>
    </div>
  </div>
  @for (dependentItem of group().MappedDependentItems; track dependentItem) {
  <div>
    <app-drag-drop-dependent-item [dependentItem]="dependentItem" [parent]="group()" (removeEvent)="removeDependentItemFromScopingItem(dependentItem, group().ScopingItemId)"></app-drag-drop-dependent-item>
  </div>
  }
</div>